module.exports = __webpack_public_path__ + "static/media/right-arrow.f652f9b6.svg";